export class MyTab {

  constructor(wrapElId) {
		this.selectedPanel = false;
		this.wrapEl = document.getElementById(wrapElId);
		if(!this.wrapEl) {
			return false;
		}
    this.tabList = this.wrapEl.querySelector('[role="tablist"]');
		this.lists = this.wrapEl.querySelectorAll('[role="tab"]');
		this.panels = this.wrapEl.querySelectorAll('[role="tabpanel"]');
    this.focusIndex = 0;

    [].forEach.call(this.lists, (btn) => {
      btn.addEventListener('click', (e) => {
        const btnEl = e.currentTarget;
        const targetId = btnEl.getAttribute('aria-controls');
        const target = document.getElementById(targetId);
        [].forEach.call(this.lists, (list) => {
          list.setAttribute('aria-selected', 'false');
          list.setAttribute('tabindex', '-1');
        });
        [].forEach.call(this.panels, (panel) => {
          panel.setAttribute('hidden', 'hidden');
        });
        target.removeAttribute('hidden');
        btnEl.setAttribute('aria-selected', 'true');
        btnEl.setAttribute('tabindex', '0');
        btnEl.focus();
        this.focusIndex = [].slice.call(this.lists).indexOf(btnEl);
        var event = new CustomEvent("tabChanged",{
          detail: {
            currentBtn: btnEl,
            currentPanel: target
          }
        });
        this.wrapEl.dispatchEvent(event);
      });
    });

    this.tabList.addEventListener("keydown", e => {
      if (e.keyCode === 39 || e.keyCode === 37) {
        if (e.keyCode === 39) {
          this.focusIndex++;
          if (this.focusIndex >= this.lists.length) { // 最後にいる場合は、最初に移動
            this.focusIndex = 0;
          }

        } else if (e.keyCode === 37) { // 左に移動
          this.focusIndex--;
          if (this.focusIndex < 0) { // 最初にいる場合は、最後に移動
            this.focusIndex = this.lists.length - 1;
          }
        }
        var event = new CustomEvent("click");
        this.lists[this.focusIndex].dispatchEvent(event);
      }
    });
	}

  element() {
    return this.wrapEl;
  }

}
